import { ThemeProvider, theme } from '@primer/react';

import deepmerge from 'deepmerge';
import { useEffect } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { BrowserRouter as Router } from 'react-router-dom';
import BaseStyles from './BaseStyles';
import { LazyPage } from './components-ui/loadable';
import LoaderPage from './components-ui/loader-page';
import { CommonProvider } from './contexts/common';
import { HubProvider } from './contexts/HubProvider';
import { AuthDataProvider } from './contexts/AuthDataProvider';
import { useAppDispatch } from './hooks/useAppDispatch';
import { useAppSelector } from './hooks/useAppSelector';
import { rootActions } from './state/actions/rootActions';
import { eReducerStatusBase } from './state/reducer-model/eReducerStatusBase';
import { appConst } from './AppConst';
import UnAuthorizedContentBackup from './content/UnAuthorizedContentBackup';
import { ExportDialogProvider } from './contexts/ExportDialogContext';
import { eAuthStatus } from './state/reducer-model/auth/IAuthReducer';
// import { HubProvider } from './contexts/HubProvider';
const AuthorizedContent = LazyPage(import("./content/AuthorizedContent"))
const UnAuthorizedContent = LazyPage(import("./content/UnAuthorizedContent"))

const customTheme = deepmerge({
  ...theme,
  fontSizes: ['11px', '13px', '16px', '20px', '24px', '32px', '40px', '48px', '56px'],
  radii: ['0px', '4px', '8px', '12px']
}, {

  colorSchemes: {
    light: {
      colors: {
        accent: {
          fg: "#017583",
          emphasis: "#017583"
        },
        btn: {
          bg: "#fff",
          primary: {
            bg: "#017583",
            focusBg: "#017583",
            hoverBg: "#017583",
            selectedBg: "#017583",
            // disabledBg: "rgba(222, 63, 15,0.6)"
            disabledBg: "rgba(1, 117, 131,0.6)"
          }
        }
      }
    }
  }
})


function App() {
  const dispatch = useAppDispatch();

  const { user, status } = useAppSelector(x => x.auth);
  const { themeMode } = useAppSelector(x => x.common.layout);

  useEffect(() => {
    if(appConst.OIDC_UNIT === "VNPT"){
      dispatch(rootActions.auth.GET_USER_INFO_VNPT_START(undefined));
    } else {
      dispatch(rootActions.auth.GET_USER_INFO_START(undefined));
    }
  }, [dispatch])

  if (status !== eReducerStatusBase.is_completed && status !== eAuthStatus.is_login_success && status !== eAuthStatus.is_logout) {
    // Đang gọi GET_USER_INFO_START, chờ kết quả
        return <LoaderPage />;
      }

  return (
    <Router>
      <CommonProvider>
        <ThemeProvider theme={customTheme} colorMode={themeMode}>
          <BaseStyles>
            {/* {status === eReducerStatusBase.is_loading &&
              <LoaderPage />

            }
            {status !== eReducerStatusBase.is_loading && */}
              <>
                {user && <>
                  <HubProvider>
                    <AuthDataProvider>
                      <ExportDialogProvider>  {/*Cái này để view report từ devexpress export ra*/}
                        <AuthorizedContent />
                      </ExportDialogProvider>
                    </AuthDataProvider>
                  </HubProvider>
                </>}
                {!user && appConst.OIDC_UNIT === "VNPT" && <UnAuthorizedContent />}
                {!user && appConst.OIDC_UNIT === "NAMVIET" && <UnAuthorizedContentBackup />}
              </>
            {/* } */}



          </BaseStyles>
        </ThemeProvider>
      </CommonProvider>
    </Router>
  );
}
export default App;
